import { performRequestThird } from 'common/apiHandler';
import { getTenantDetails } from 'utils/utils';

/**
 * Get fuzzy suggestions from the API
 * @param {string} tenantId - Tenant identifier
 * @param {string} searchKeyword - The keyword to search for
 * @param {string} category - Entity type/category (must be one of the allowed categories)
 * @returns {Promise<Object>} API response with suggestions
 */
export const getFuzzySuggestions = async (tenantId, searchKeyword, category = 'location') => {
  try {
    const [tenantIdFromUtils] = getTenantDetails();

    const response = await performRequestThird(
      'GET',
      `/fetch-suggestions?tenant_id=${tenantIdFromUtils}&search_keyword=${searchKeyword}&category=${category}`
    );

    return response;
  } catch (error) {
    console.error('Error fetching fuzzy suggestions:', error);
    throw error;
  }
};

/**
 * Get location suggestions specifically
 * @param {string} tenantId - Tenant identifier (not used, will get from utils)
 * @param {string} searchKeyword - The keyword to search for
 * @returns {Promise<Array>} Array of location suggestions
 */
export const getLocationSuggestions = async (tenantId, searchKeyword) => {
  try {
    const response = await getFuzzySuggestions(tenantId, searchKeyword, 'location');

    // Transform the API response to match our component's expected format
    console.log('Raw API Response:', response);

    if (response?.data?.suggestions) {
      const transformedSuggestions = response.data.suggestions.map((suggestion) => {
        // Ensure we have a proper display string
        const displayText = suggestion.title || suggestion.name || suggestion.entity_id || 'Unknown';

        return {
          label: displayText,
          value: suggestion.entity_id,
          title: suggestion.title,
          contact_type: suggestion.contact_type,
          res_type: suggestion.res_type,
          first_name: suggestion.first_name,
          last_name: suggestion.last_name,
          email: suggestion.email,
          phone: suggestion.phone,
        };
      });

      console.log('Transformed suggestions:', transformedSuggestions);
      return transformedSuggestions;
    }

    console.log('No suggestions found in response');
    return [];
  } catch (error) {
    console.error('Error fetching location suggestions:', error);
    return [];
  }
};

/**
 * Get provider suggestions specifically
 * @param {string} tenantId - Tenant identifier (not used, will get from utils)
 * @param {string} searchKeyword - The keyword to search for
 * @returns {Promise<Array>} Array of provider suggestions
 */
export const getProviderSuggestions = async (tenantId, searchKeyword) => {
  try {
    const response = await getFuzzySuggestions(tenantId, searchKeyword, 'medical_provider');

    // Transform the API response to match our component's expected format
    console.log('Raw API Response:', response);

    if (response?.data?.suggestions) {
      const transformedSuggestions = response.data.suggestions.map((suggestion) => {
        // Ensure we have a proper display string
        const displayText = suggestion.title || suggestion.name || suggestion.entity_id || 'Unknown';

        return {
          label: displayText,
          value: suggestion.entity_id,
          title: suggestion.title,
          contact_type: suggestion.contact_type,
          res_type: suggestion.res_type,
          first_name: suggestion.first_name,
          last_name: suggestion.last_name,
          email: suggestion.email,
          phone: suggestion.phone,
        };
      });

      console.log('Transformed suggestions:', transformedSuggestions);
      return transformedSuggestions;
    }

    console.log('No suggestions found in response');
    return [];
  } catch (error) {
    console.error('Error fetching provider suggestions:', error);
    return [];
  }
};
